import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

import Swiper from "swiper";
import { Navigation, Pagination } from "swiper/modules";

export function initSwiperCarousel() {
    const carousels = document.querySelectorAll(".related-post-carousel");
	if (!carousels.length) return;

	carousels.forEach((el) => {
		const swiper = new Swiper(el, {
			modules: [
				Navigation,
				Pagination
			],
			slidesPerView: 1,
			loop: false,
			speed: 1000,
			spaceBetween: 32,
			autoHeight: true,
			navigation: {
				nextEl: el.querySelector(".swiper-button-next"),
				prevEl: el.querySelector(".swiper-button-prev"),
			},
			pagination: {
				el: el.querySelector(".swiper-pagination"),
				clickable: true,
			},
			autoplay: false,
			breakpoints: {
				576: { 
					slidesPerView: "auto",
					autoHeight: false,
				},
			},
		});
	});
}